import { FC, useContext } from "react";
import DataTable from "../../../../../shared/components/dataTable";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import Loader from "../../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import SearchBox from "../../../../../layouts/SidebarLayout/Header/SearchBox";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";

const IndustryList: FC = () => {
  const navigate = useNavigate();
  const { payload, setPayload } = useContext(SidebarContext);

  const { loading, data, fetchData, error } = useQuery("/industry", {
    params: {
      ...payload,
    },
  });

  const industryData = data as any;

  const navigateToDetails = () => {
    navigate("/master-datas/industries/create");
  };

  const industryDisplayColumns = ["name", "enabled"];
  const titleBarNode = <SearchBox />;
  const titleBar = {
    title: "Industries",
    headerTitle: "Industries",
    buttonTitle: "Create",
    titleBarNodes: (industryData?.totalItems || payload.search) && titleBarNode,
    onClick: navigateToDetails,
    disabled: industryData?.entityPermissions
      ? !industryData?.entityPermissions?.includes("Industry-Create")
      : false,
    subHeading: "",
    rowCount: industryData?.totalItems,
  };

  return (
    <TableViewContainer titleBar={titleBar}>
      {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
        <DataTable
          entityName="Industry"
          data={industryData?.items ?? []}
          displayColumns={industryDisplayColumns}
          linkColumn="name"
          linkUrl="/master-datas/industries"
          pagination={{ take: payload.take, skip: payload.skip }}
          setPagination={setPayload}
          totalItems={industryData?.totalItems}
          deleteApiUrl="/industry"
          refetchFunction={fetchData}
          disabled={
            industryData?.entityPermissions
              ? !industryData?.entityPermissions?.includes("Industry-Delete")
              : false
          }
        />
      )}
    </TableViewContainer>
  );
};

export default IndustryList;
